import { Controller } from "@hotwired/stimulus"
import Honeybadger from "@honeybadger-io/js"

// Controls the warning modal when shortening a trade would remove assignments.
// Uses native <dialog> element with showModal() for proper top-layer rendering.
export default class extends Controller {
  static values = {
    taskId: Number,
    tradeId: Number,
    newStartDate: String,
    newEndDate: String,
    viewMode: String,
    viewStartDate: String,
  }

  connect() {
    // Show dialog as modal
    this.element.showModal()

    // Handle native close event
    this.boundHandleClose = this.handleClose.bind(this)
    this.element.addEventListener("close", this.boundHandleClose)

    // Close when clicking the backdrop
    this.boundHandleClick = this.handleClick.bind(this)
    this.element.addEventListener("click", this.boundHandleClick)
  }

  disconnect() {
    this.element.removeEventListener("close", this.boundHandleClose)
    this.element.removeEventListener("click", this.boundHandleClick)
  }

  handleClose() {
    // Remove from DOM after dialog closes
    this.element.remove()
  }

  handleClick(event) {
    // Close when clicking the backdrop
    if (event.target === this.element) {
      this.close()
    }
  }

  close() {
    this.element.close()
  }

  proceed() {
    const csrfToken = document.head
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content")

    const url = `/plantafel/tasks/${this.taskIdValue}/trades/${this.tradeIdValue}/schedule`
    const data = {
      task_trade: {
        start_date: this.newStartDateValue,
        end_date: this.newEndDateValue,
      },
      force: true,
      view_mode: this.viewModeValue,
      view_start_date: this.viewStartDateValue,
    }

    // Close modal first
    this.close()

    fetch(url, {
      method: "PATCH",
      credentials: "same-origin",
      headers: {
        "X-CSRF-Token": csrfToken,
        Accept: "text/vnd.turbo-stream.html",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        const contentType = response.headers.get("Content-Type") || ""
        const html = await response.text()

        if (contentType.includes("text/vnd.turbo-stream.html")) {
          Turbo.renderStreamMessage(html)

          // Dispatch event to refresh the trade drawer if it's open
          document.dispatchEvent(
            new CustomEvent("plantafel:trade-schedule-changed", {
              detail: { taskId: this.taskIdValue, tradeId: this.tradeIdValue },
            }),
          )
        } else if (!response.ok) {
          Honeybadger.notify(`Failed to shorten trade schedule: ${response.status}`, {
            context: {
              level: "error",
              component: "plantafel-trade-shorten-warning",
              action: "force_shorten",
            },
          })
        }
      })
      .catch((error) => {
        Honeybadger.notify(error, {
          context: { component: "plantafel-trade-shorten-warning", action: "force_shorten" },
        })
      })
  }
}
